import React from "react";
import {TextField} from "@mui/material";
import {forms, objects} from "@atttomyx/shared-utils";
import {sortingUtils} from "../../utils";

const UpsellForm = (props) => {
    const { showOrder, data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = modified.name
            && (!showOrder || sortingUtils.isSortable(modified.order));

        onSync(modified);
    };

    return <div className="upsell-form">
        <div className="field top-margin">
            <TextField
                required={true}
                label="Name"
                type="text"
                value={forms.sanitizeValue(data.name)}
                onChange={(event) => onChange("name", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                multiline={true}
                label="Description"
                type="text"
                value={forms.sanitizeValue(data.description)}
                onChange={(event) => onChange("description", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Landing Page URL"
                type="text"
                value={forms.sanitizeValue(data.landingPageUrl)}
                onChange={(event) => onChange("landingPageUrl", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Price"
                type="number"
                value={forms.sanitizeValue(data.price)}
                onChange={(event) => onChange("price", event.target.value)}
                inputProps={{
                    min: 0,
                }}
            />
        </div>
        {showOrder ?
            <div className="field">
                <TextField
                    required={true}
                    label="Index"
                    type="number"
                    value={forms.sanitizeValue(data.order)}
                    onChange={(event) => onChange("order", event.target.value)}
                    inputProps={{
                        step: 1,
                        min: 0,
                    }}
                />
            </div> : null}
    </div>
}

export default UpsellForm;
